import { render, staticRenderFns } from "./student.vue?vue&type=template&id=4eaff1a6&scoped=true"
import script from "./student.vue?vue&type=script&lang=js"
export * from "./student.vue?vue&type=script&lang=js"
import style0 from "./student.vue?vue&type=style&index=0&id=4eaff1a6&prod&lang=scss&scoped=true"
import style1 from "./student.vue?vue&type=style&index=1&id=4eaff1a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eaff1a6",
  null
  
)

export default component.exports